import React, { Component } from 'react';
import './App.css';
import {
  Switch,
  Route,
  Redirect,
  withRouter,
} from 'react-router-dom';
import {connect} from 'react-redux';

// icons
import fontawesome from '@fortawesome/fontawesome'
import brands from '@fortawesome/fontawesome-free-brands'
import faCheckSquare from '@fortawesome/fontawesome-free-solid/faCheckSquare'
import faFreeSolid from '@fortawesome/fontawesome-free-solid';

// comps
import HomePage from './main/HomePage';
import ProgramsPage from './main/ProgramsPage';
import ContactPage from './main/ContactPage';
import DesignPage from './main/DesignPage';
import FlexHeader from './main/FlexHeader';
import Footer from './main/Footer';
import {updateLang} from './actions';
import { parseUrlForKey } from './utils';
import {LANG} from './constants';

// icon library
fontawesome.library.add(
  brands,
  faCheckSquare,
  faFreeSolid)


class App extends Component {
  componentDidMount() {
    const {updateLang} = this.props;
    const {search} = this.props.location;
    const lang = parseUrlForKey('lang', search);
    const langValues = Object.values(LANG);
    if (lang && langValues.includes(lang)) {
      updateLang({lang});
    }
  }

  render() {
    return (
      <div className="App" style={s.container}>
        <FlexHeader />
        <div style={s.content} className='App-content'>
          <Switch>
            <Route
              path="/home"
              exact={true}
              component={HomePage}
            />
          
            <Route
              path="/programs"
              exact={true}
              component={ProgramsPage}
            />

            <Route
              path="/contact"
              exact={true}
              component={ContactPage}
            />

            <Route
              path="/design-page"
              exact={true}
              component={DesignPage}
            />

            <Redirect to="/home" />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

const s = {
  container: {

  },
  content: {
    marginTop: FlexHeader.HEIGHT,
    //border: 'solid blue'
  },
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateLang: (params) => dispatch(updateLang(params)),
  }
}


const Connected = connect(
  null,
  mapDispatchToProps
)(App)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/App.js